import axios from "axios";

// Base URL setup
const BASE_URL = `${process.env.REACT_APP_BASE_URL}/employees`;

// Helper: Get token and apply to headers
const setTokenHeader = () => {
    const token = localStorage.getItem("adminToken");
    if (token) {
        axios.defaults.headers.common["Authorization"] = token;
    }
};

// Helper: Common GET with default no-cache headers
const axiosGet = async (url, params = {}) => {
    try {
        setTokenHeader();
        // const startTime = Date.now();
        const response = await axios.get(url, {
            params,
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            },
        });
        // const endTime = Date.now();
        // console.log(`[GET] ${url} - ${endTime - startTime}ms`);
        return response.data;
    } catch (error) {
        console.error(`GET ${url} failed:`, error);
        throw error;
    }
};

// Helper: Common POST with token
const axiosPost = async (url, body = {}) => {
    try {
        setTokenHeader();
        const response = await axios.post(url, body);
        return response.data;
    } catch (error) {
        console.error(`POST ${url} failed:`, error);
        throw error;
    }
};

// Get All Employees
const getAllEmployees = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = {} }) => {
    let sendStatus = status === 0 ? null : status;
    const search = filterModel?.quickFilterValues?.[0] ?? null;

    return await axiosGet(`${BASE_URL}/get`, {
        limit,
        page,
        sendStatus,
        search,
        sort: sortModel,
    });
};

// Get Employee Details
const getEmployeeDetails = async ({ employeeId }) => {
    return await axiosGet(`${BASE_URL}/detail`, { id: employeeId });
};

// Update Employee Status
const updateEmployeeStatus = async (params) => {
    return await axiosPost(`${BASE_URL}/status/`, { ...params });
};

const getDepartments = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = {} }) => {
    let sendStatus = status === 0 ? null : status;
    const search = filterModel?.quickFilterValues?.[0] ?? null;

    return await axiosGet(`${BASE_URL}/departments`, {
        limit,
        page,
        sendStatus,
        search,
        sort: sortModel,
    });
};
const getDesignations = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = {} }) => {
    let sendStatus = status === 0 ? null : status;
    const search = filterModel?.quickFilterValues?.[0] ?? null;

    return await axiosGet(`${BASE_URL}/designations`, {
        limit,
        page,
        sendStatus,
        search,
        sort: sortModel,
    });
};
const createEmployee = async (employeeData) => {
    return await axiosPost(`${BASE_URL}/create`, employeeData);
  
};

// Export the API functions
const employeeApi = {
    getAllEmployees,
    getEmployeeDetails,
    updateEmployeeStatus,
    getDepartments,
    getDesignations,
    createEmployee,
};

export default employeeApi;
